<template>
  <div class="boxall">
    <div class="page-head">
      <div class="title">溯源管理</div>
      <!-- <span class="btn-container">
        <button class="detail-btn" @click="openDetail">
          {{ opened ? '返回' : '详情' }}
          <img src="../assets/images/more_arrow.png" alt="icon" />
        </button>
      </span> -->
    </div>

    <div class="boxnav">
      <div class="bg-image">
        <div class="qrcode" @click="openDetail"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TraceManage',

  computed: {
    opened() {
      return this.activeComp === 'TraceDetail'
    }
  },

  methods: {
    openDetail() {
      this.$emit('switchCenter')
    }
  }
}
</script>

<style scoped>
.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/trace_bg.png') no-repeat center center;
  background-size: cover;
  border-radius: 0.15rem;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  position: relative;
}

.qrcode {
  /* border: 1px solid orangered; */
  position: absolute;
  top: 43px;
  right: 29px;
  height: 95px;
  width: 95px;

  background: url('../assets/images/qrcode.png') no-repeat center center;
  background-size: cover;

  cursor: pointer;
}

.page-head {
  position: relative;
}

.btn-container {
  position: absolute;
  top: 8px;
  right: 8px;
}

.detail-btn {
  background: #c7e9f600;
  padding: 2.4px 5px;
  color: #49d8ec;
  font-size: 12px;
  border-radius: 6.4px;
  border: 1.6px solid #49d8ec;
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.4), inset 0 0 12px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
  cursor: pointer;
}

.detail-btn img {
  height: 8px;
  width: 8px;
}
</style>
